<div class="filter-header">
  <h3 class="filter-headline font-2xl">
    {{ "features.product-overview.productFamilyFilter.headline" | translate }}
  </h3>
  <button
    type="button"
    (click)="handleFilterCloseClick()"
    [title]="
      'pia.features.product-overview.productFamilyAside.closeFilterButtonLabel'
        | translate
    "
    class="close-button icon-only-button"
  >
    <claas-icon
      [iconId]="'006172'"
      [namespace]="'pia'"
      [size]="24"
      [alt]="''"
      [removeDefaultColor]="true"
    ></claas-icon>
  </button>
</div>
<p class="filter-sub-headline font-xs">
  {{ "features.product-overview.productFamilyFilter.subHeadline" | translate }}
</p>
<p class="filter-instructions font-xs">
  {{ "features.product-overview.productFamilyFilter.instructions" | translate }}
</p>
<ul class="filter-list">
  @for (productFamily of this.productFamilies(); track productFamily.ID) {
    @if (typeof productFamily.Name === "string" && productFamily.ID) {
      <li class="filter-list-item">
        <label
          class="filter-wrap"
          [for]="'product-fam-filter-' + productFamily.ID"
        >
          <mat-checkbox
            [checked]="!productFamilyIdsExcluded()?.includes(productFamily.ID)"
            (change)="handleFilterCheckboxChange($event, productFamily.ID)"
            class="filter-mat-checkbox"
            [id]="'product-fam-filter-' + productFamily.ID"
          >
            <span>
              <claas-icon
                [iconId]="
                  productFamily.ID && productFamilyIconMap[productFamily.ID]
                    ? productFamilyIconMap[productFamily.ID]
                    : '783162'
                "
                [namespace]="'pia'"
                [attr.aria-hidden]="true"
                [size]="24"
                [alt]="''"
                [removeDefaultColor]="true"
              >
              </claas-icon>
            </span>
            <span class="font-m"> {{ productFamily.Name }} </span>
          </mat-checkbox>
        </label>
      </li>
    }
  }
</ul>
